import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class 
OTPService {

    static _instance: OTPService;

    constructor(private otpRestService: OTPRESTService) { } 

    getPayloadData(externalId: string) {
        let parameters = new HttpParams();
        return this.otpRestService.get(OTPRESTService.API_PAYLOAD + "/" + externalId, parameters);
    }

    makePayment(externalId: string, body: any) {
        let parameters = new HttpParams().set(OTPRESTService.REQUEST_PARAM_EXTERNAL_ID, externalId);        
        return this.otpRestService.post_(OTPRESTService.API_PAYMENT, parameters, body);
    }

    getReceipt(nmiTransactionId: string, body: any) {
        let parameters = new HttpParams().set(OTPRESTService.REQUEST_PARAM_NMI_TRANSACTION_ID, nmiTransactionId);        
        return this.otpRestService.post_(OTPRESTService.API_RECEIPT, parameters, body);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OTPRESTService {

    private static readonly API_ENDPOINT = '/otp';
    public static readonly API_PAYLOAD = '/paydata';
    public static readonly API_PAYMENT = "/payment";
    public static readonly API_RECEIPT = "/receipt";
    
    private static readonly JSON_CONTENT_TYPE = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    
    public static readonly REQUEST_PARAM_EXTERNAL_ID = 'externalId';
    public static readonly REQUEST_PARAM_NMI_TRANSACTION_ID = 'nmiTransactionId';

    constructor(private http: HttpClient) { }

    // REST API =======================================================

    public post_(path: string, parameters: any, body: any): Observable<any> {
        return this.http.post<any>(OTPRESTService.API_ENDPOINT + path, body, { params: parameters, headers: OTPRESTService.JSON_CONTENT_TYPE, observe: "response" });
    }

    public get(path: string, parameters: any): Observable<any> {
        return this.http.get<any>(OTPRESTService.API_ENDPOINT + path, { params: parameters, observe: "response" });
    }
}
